import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { MainMenuElement } from '@m4u-angular/base/classes/BaseClasses';
import { BaseComponent } from '@m4u-angular/base/component/BaseComponent';
import { ServiceBagService, ServiceBagServices } from '@m4u-angular/base/component/ServiceBag';
import { BaseState } from '@m4u-angular/base/entities/BaseEntities';
import { BottomSheetService } from '@m4u-angular/core/framework/bottom-sheet.service';
import { ResourcesService } from '@m4u-angular/core/framework/resources.service';
import { RouteHistoryService } from '@m4u-angular/core/framework/route-history.service';
import { SessionService } from '@m4u-angular/core/framework/session.service';
import { Utils } from '@m4u-angular/core/helpers/Utils';
import { combineLatest, Observable, Subscription } from 'rxjs';

class State extends BaseState {
    NavbarItems: MainMenuElement[] = [];
    SelectedIndex: number;
}

@Component({
    providers: ServiceBagServices,
    selector: 'app-nav-bar',
    templateUrl: './nav-bar.component.html',
    styleUrls: ['./nav-bar.component.scss']
})
export class NavBarComponent extends BaseComponent<State> {

    private _navbarItems$: Observable<MainMenuElement[]>;
    private _subscriptions: Subscription[] = [];

    constructor(A: ServiceBagService,
        private sessionService: SessionService,
        private resourceService: ResourcesService,
        private router: Router,
        private bottomSheetService: BottomSheetService,
        private routeHistoryService: RouteHistoryService) {
        super(A, 'NavBarComponent', State);
    }

    protected override OnInitComponent(): void {
        this._navbarItems$ = this.A.AppConfigService.AppConfig.OnGetNavbarItems(this.sessionService.UserInfoDict);
        this._subscriptions.push(this._navbarItems$.subscribe(items => {
            items.forEach(item => this.InitializeItem(item));
            this.State.NavbarItems = items;
        }));
        this._subscriptions.push(
            combineLatest([this._navbarItems$, this.A.SysEvents.SelectedRoute]).subscribe(([navbarItems, selectedRoute]) => {
                this.State.SelectedIndex = selectedRoute ? navbarItems.findIndex(x => x.menu === selectedRoute) : undefined;
            })
        );
        
    }

    OnItemClick(idx) {
        if (idx == this.State.SelectedIndex) return;

        const menu = this.State.NavbarItems[idx];

        this.routeHistoryService.ClearHistory();

        const menuUserInfo = menu.moduleName ? this.sessionService.UserInfoDict[menu.moduleName] : this.sessionService.UserInfos[0];
        const navigateParams = menu.pathParams && menu.pathParams(menuUserInfo) || [];
        navigateParams.unshift(menu.path);
       
        this.A.Navigator.Navigate(navigateParams, menu.queryParams || null);
    }

    private InitializeItem(menu: MainMenuElement): void {
        menu.text = this.GetItemTranslation(menu);
        menu.visible = this.GetItemVisible(menu);
    }

    private GetItemTranslation(menu: MainMenuElement): string {
        return menu.text || this.resourceService.RC(`$$Pages.${menu.menu}`, menu.moduleName);
    }

    private GetItemVisible(menu: MainMenuElement) {
        const menuUserInfo = menu.moduleName && this.sessionService.UserInfoDict[menu.moduleName];
        var permissionResult = Utils.IsEmpty(menu.permission) ? true : menuUserInfo && menuUserInfo.hasOwnProperty(menu.permission) && menuUserInfo[menu.permission];
        var permissionFunctionResult = Utils.IsEmpty(menu.permissionFunction) ? true : this.sessionService.UserInfos.some(x => x && menu.permissionFunction(x));

        return !!permissionResult && permissionFunctionResult;
    }

    protected override OnDestroyComponent(): void {
        this._subscriptions.forEach(x => x.unsubscribe());
    }
}
